import { create } from 'zustand';
import type { AggregateResponse, SessionResult } from '../types';

type UploadState = 'idle' | 'ready' | 'uploading' | 'uploaded' | 'failed';

interface LabStore {
  aggregate: AggregateResponse | null;
  lastResult: SessionResult | null;
  uploadState: UploadState;
  uploadError: string | null;
  setAggregate: (aggregate: AggregateResponse | null) => void;
  setLastResult: (result: SessionResult | null) => void;
  setUploadState: (state: UploadState, error?: string | null) => void;
}

export const useLabStore = create<LabStore>((set) => ({
  aggregate: null,
  lastResult: null,
  uploadState: 'idle',
  uploadError: null,
  setAggregate: (aggregate) => set({ aggregate }),
  setLastResult: (lastResult) => set({ lastResult, uploadState: lastResult ? 'ready' : 'idle', uploadError: null }),
  setUploadState: (uploadState, uploadError = null) => set({ uploadState, uploadError })
}));
